
export default {
  init() {
    // JavaScript to be fired on pages that use the content cards mixed media layout
    $(document).ready(function () {

        $(window).on('resize load', function () {
          if ($(window).width() > 961) {
            // $('.layout-content_cards_mixed_media .content-columns').removeAttr('uk-slider')
            $('.layout-content_cards_mixed_media .content-columns').find('> div > div').removeClass('uk-slider-items').css('transform', 'none')
            //$('.layout-content_alternating_sections .alternating-section > div').removeClass('uk-slider-items').css('transform', 'none')
          }
          else {
            console.log('here')
            $('.layout-content_cards_mixed_media .content-columns').attr('uk-slider')
            $('.layout-content_cards_mixed_media .content-columns').find('> div > div').addClass('uk-slider-items')
            //$('.layout-content_alternating_sections .alternating-section > div').addClass('uk-slider-items')
          }
        })
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the content cards mixed media layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/mixedMediaCards.js